import type { SelectFieldOption } from '@/features/proposals/hooks/form-fields';
import {
  findPremiumPeriodicityOption,
  type CapitalGlobalPremiumPeriodicityOption,
} from '@/features/proposals/components/capital-global/utils/capital-global-installment-periodicity.util';
import { formatCurrency } from '@/shared/utils';

export const CAPITAL_GLOBAL_PROPOSAL_PREMIUM_PERIODICITY_ALERT =
  'Selecione a periodicidade do prêmio para ver o valor!';

export const CAPITAL_GLOBAL_PROPOSAL_PREMIUM_EMPTY_DISPLAY = 'R$ 000,00';

export function getCapitalGlobalProposalPremiumPeriodicity(
  value: string,
  catalogOptions: CapitalGlobalPremiumPeriodicityOption[] = []
): CapitalGlobalPremiumPeriodicityOption | undefined {
  return findPremiumPeriodicityOption(catalogOptions, value);
}

export function toPremiumPeriodicitySelectOptions(
  catalogOptions: CapitalGlobalPremiumPeriodicityOption[]
): SelectFieldOption[] {
  return catalogOptions.map(({ value, label }) => ({ value, label }));
}

export function getCapitalGlobalProposalPremiumAmountLabel(
  premiumPeriodicity: string,
  annualPremiumAmount: number | null,
  catalogOptions: CapitalGlobalPremiumPeriodicityOption[] = []
): string {
  const periodicity = getCapitalGlobalProposalPremiumPeriodicity(
    premiumPeriodicity,
    catalogOptions
  );
  if (!periodicity) return CAPITAL_GLOBAL_PROPOSAL_PREMIUM_EMPTY_DISPLAY;
  if (annualPremiumAmount == null || !Number.isFinite(annualPremiumAmount)) {
    return CAPITAL_GLOBAL_PROPOSAL_PREMIUM_EMPTY_DISPLAY;
  }
  return formatCurrency(annualPremiumAmount / periodicity.installmentCount);
}
